/* vm-rasse-detail.js — Sprint 3 v2 mit Tooltip-Body-Reparent-Fix (2026-05-14) */
(function () {
  'use strict';

  function initTabs() {
    var tabs = document.querySelectorAll('.vm-tab[data-tab]');
    var tabContents = document.querySelectorAll('.vm-tab-content[data-tab-content]');
    if (!tabs.length || !tabContents.length) return;
    function activateTab(targetId) {
      tabs.forEach(function (tab) {
        var isActive = tab.dataset.tab === targetId;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      tabContents.forEach(function (panel) {
        if (panel.dataset.tabContent === targetId) {
          panel.removeAttribute('hidden');
          panel.focus && panel.focus({ preventScroll: true });
        } else { panel.setAttribute('hidden', ''); }
      });
      try { history.replaceState(null, '', '#' + targetId); } catch (e) {}
    }
    tabs.forEach(function (tab) { tab.addEventListener('click', function () { activateTab(tab.dataset.tab); }); });
    tabs.forEach(function (tab, idx) {
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[idx + 1] || tabs[0];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[idx - 1] || tabs[tabs.length - 1];
        else if (e.key === 'Enter' || e.key === ' ') { activateTab(tab.dataset.tab); return; }
        if (next) { next.focus(); activateTab(next.dataset.tab); }
      });
    });
    var hash = window.location.hash.replace('#', '');
    var validTabs = ['uebersicht', 'charakter', 'eignung', 'gesundheit', 'geschichte', 'studien'];
    if (hash && validTabs.indexOf(hash) !== -1) activateTab(hash);
    else activateTab('uebersicht');
  }

  function setTabNavHeight() {
    var nav = document.getElementById('vm-tab-nav');
    if (nav) document.documentElement.style.setProperty('--vm-tab-nav-height', nav.offsetHeight + 'px');
  }

  function initCheckliste() {
    var checkboxes = document.querySelectorAll('.vm-checkliste__checkbox');
    var counterEl = document.querySelector('.vm-checkliste__counter');
    var resultEl = document.querySelector('.vm-checkliste__result');
    var resultPass = document.querySelector('.vm-checkliste__result--pass');
    var resultFail = document.querySelector('.vm-checkliste__result--fail');
    if (!checkboxes.length) return;
    var total = checkboxes.length;
    function updateCounter() {
      var checked = 0;
      checkboxes.forEach(function (cb) { if (cb.checked) checked++; });
      if (counterEl) counterEl.textContent = checked + ' / ' + total + ' erfüllt';
      if (resultEl) {
        if (checked === 0) { resultEl.style.display = 'none'; if (resultPass) resultPass.style.display = 'none'; if (resultFail) resultFail.style.display = 'none'; }
        else if (checked >= 6) { resultEl.style.display = 'block'; if (resultPass) resultPass.style.display = 'block'; if (resultFail) resultFail.style.display = 'none'; }
        else { resultEl.style.display = 'block'; if (resultPass) resultPass.style.display = 'none'; if (resultFail) resultFail.style.display = 'block'; }
      }
    }
    checkboxes.forEach(function (cb) { cb.addEventListener('change', updateCounter); });
    updateCounter();
  }

  function initMap() {
    var mapContainer = document.querySelector('.vm-map-container');
    if (!mapContainer) return;
    var pinsData = mapContainer.getAttribute('data-pins');
    if (!pinsData) return;
    var pins; try { pins = JSON.parse(pinsData); } catch (e) { return; }
    var coordsEl = document.getElementById('vm-country-coords');
    var coords = {};
    if (coordsEl) { try { coords = JSON.parse(coordsEl.textContent); } catch (e) {} }
    var svgEl = mapContainer.querySelector('svg');
    if (!svgEl) return;
    var mapW = svgEl.viewBox.baseVal.width || 1000;
    var mapH = svgEl.viewBox.baseVal.height || 500;
    function latlngToXY(lat, lng) { return [(lng + 180) / 360 * mapW, (90 - lat) / 180 * mapH]; }
    var overlay = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    overlay.setAttribute('class', 'vm-map-pins');
    pins.forEach(function (pin) {
      var landCoords = coords[pin.land];
      if (!landCoords) return;
      var xy = latlngToXY(landCoords[0], landCoords[1]);
      var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      g.setAttribute('class', 'vm-map-pin-svg' + (pin.punkt === 'ursprung' ? ' vm-map-pin-svg--ursprung' : ''));
      g.setAttribute('transform', 'translate(' + xy[0] + ',' + xy[1] + ')');
      if (pin.punkt === 'ursprung') {
        var pulse = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        pulse.setAttribute('r', '12'); pulse.setAttribute('fill', 'rgba(107,142,90,0.2)'); pulse.setAttribute('class', 'vm-pin-pulse');
        g.appendChild(pulse);
      }
      var dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      dot.setAttribute('r', '5'); dot.setAttribute('fill', pin.punkt === 'ursprung' ? '#6B8E5A' : '#8B2E3D');
      dot.setAttribute('stroke', '#fff'); dot.setAttribute('stroke-width', '1.5');
      g.appendChild(dot);
      var t = document.createElementNS('http://www.w3.org/2000/svg', 'title');
      t.textContent = pin.land + ' (' + pin.jahr + '): ' + pin.beschreibung;
      g.appendChild(t);
      overlay.appendChild(g);
    });
    svgEl.appendChild(overlay);
    if (pins.length > 1) {
      var arrowGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      arrowGroup.setAttribute('class', 'vm-map-arrows');
      for (var i = 0; i < pins.length - 1; i++) {
        var p1 = pins[i], p2 = pins[i + 1];
        var c1 = coords[p1.land], c2 = coords[p2.land];
        if (!c1 || !c2) continue;
        var xy1 = latlngToXY(c1[0], c1[1]), xy2 = latlngToXY(c2[0], c2[1]);
        var mx = (xy1[0] + xy2[0]) / 2;
        var my = Math.min(xy1[1], xy2[1]) - 30;
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M ' + xy1[0] + ' ' + xy1[1] + ' Q ' + mx + ' ' + my + ' ' + xy2[0] + ' ' + xy2[1]);
        path.setAttribute('fill', 'none'); path.setAttribute('stroke', '#C9963F');
        path.setAttribute('stroke-width', '1.5'); path.setAttribute('stroke-dasharray', '4 3'); path.setAttribute('opacity', '0.7');
        arrowGroup.appendChild(path);
      }
      svgEl.insertBefore(arrowGroup, overlay);
    }
  }

  function initDonuts() {
    document.querySelectorAll('.vm-risk-card__donut[data-value]').forEach(function (el) {
      var val = parseFloat(el.getAttribute('data-value')) || 0;
      var max = parseFloat(el.getAttribute('data-max')) || 5;
      var pct = Math.min(val / max, 1);
      var r = 28; var circ = 2 * Math.PI * r;
      var dash = pct * circ; var gap = circ - dash;
      var color;
      if (pct >= 0.7) color = '#8B2E3D';
      else if (pct >= 0.4) color = '#C9963F';
      else color = '#6B8E5A';
      var svg = el.querySelector('svg');
      if (!svg) {
        svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 64 64'); svg.setAttribute('width', '64'); svg.setAttribute('height', '64');
        var track = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        track.setAttribute('cx', '32'); track.setAttribute('cy', '32'); track.setAttribute('r', String(r));
        track.setAttribute('fill', 'none'); track.setAttribute('stroke', '#fff8e7'); track.setAttribute('stroke-width', '6');
        svg.appendChild(track);
        var arc = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        arc.setAttribute('cx', '32'); arc.setAttribute('cy', '32'); arc.setAttribute('r', String(r));
        arc.setAttribute('fill', 'none'); arc.setAttribute('stroke', color); arc.setAttribute('stroke-width', '6');
        arc.setAttribute('stroke-dasharray', dash.toFixed(2) + ' ' + gap.toFixed(2));
        arc.setAttribute('stroke-linecap', 'round');
        arc.setAttribute('transform', 'rotate(-90 32 32)');
        arc.setAttribute('class', 'vm-donut-arc');
        svg.appendChild(arc);
        el.insertBefore(svg, el.firstChild);
      }
    });
  }

  function initScoreBars() {
    var bars = document.querySelectorAll('.vm-score-bar__fill');
    if (!bars.length) return;
    bars.forEach(function (bar) {
      var target = bar.style.getPropertyValue('--score');
      bar.dataset.targetScore = target;
      bar.style.setProperty('--score', '0%');
    });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var bar = entry.target;
            setTimeout(function () { bar.style.setProperty('--score', bar.dataset.targetScore); }, 100);
            observer.unobserve(bar);
          }
        });
      }, { threshold: 0.1 });
      bars.forEach(function (bar) { observer.observe(bar); });
    } else {
      bars.forEach(function (bar) { bar.style.setProperty('--score', bar.dataset.targetScore); });
    }
  }

  function setHeaderHeight() {
    var totalHeight = 0;
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      var style = getComputedStyle(s);
      var pos = style.position;
      if (pos === 'sticky' || pos === '-webkit-sticky') {
        var rect = s.getBoundingClientRect();
        if (rect.top >= -5 && rect.top <= 20) totalHeight += s.offsetHeight;
      }
    });
    if (totalHeight === 0) {
      var header = document.querySelector('.shopify-section-header.shopify-section-group-header-group, .shopify-section[id*="header"], header.site-header, header[role="banner"]');
      totalHeight = header ? header.offsetHeight : 108;
    }
    document.documentElement.style.setProperty('--header-height', totalHeight + 'px');
  }

  /* === Sprint 3 v2 (2026-05-14): Score-Tooltips mit Cursor-Tracking
     FIX: Tooltip-DOM zu body.appendChild umziehen, weil .vm-score-bar-group + .vm-tab-content
     transform: matrix() haben — das macht position:fixed zu "relativ zum transformed ancestor".
     Reparent zu document.body bricht den containing block. === */
  function initScoreTooltips() {
    document.querySelectorAll('.vm-score-bar__label-btn').forEach(function (btn) {
      var tooltipId = btn.getAttribute('data-tooltip-id');
      if (!tooltipId) return;
      var tooltip = document.getElementById(tooltipId);
      if (!tooltip) return;

      // Reparent to body for proper position:fixed (CSS containing-block fix)
      if (tooltip.parentElement !== document.body) {
        document.body.appendChild(tooltip);
      }

      function positionAtPoint(clientX, clientY) {
        var offset = 16;
        var x = clientX + offset;
        var y = clientY + offset;
        var wasHidden = tooltip.hidden;
        if (wasHidden) { tooltip.style.visibility = 'hidden'; tooltip.hidden = false; }
        var tw = tooltip.offsetWidth || 320;
        var th = tooltip.offsetHeight || 100;
        if (wasHidden) { tooltip.hidden = true; tooltip.style.visibility = ''; }
        if (x + tw > window.innerWidth - 8) x = clientX - tw - offset;
        if (y + th > window.innerHeight - 8) y = clientY - th - offset;
        if (x < 8) x = 8;
        if (y < 8) y = 8;
        tooltip.style.top = y + 'px';
        tooltip.style.left = x + 'px';
      }

      function showAt(e) { positionAtPoint(e.clientX, e.clientY); tooltip.hidden = false; }
      function followCursor(e) { if (tooltip.hidden) return; positionAtPoint(e.clientX, e.clientY); }
      function hideTooltip() { tooltip.hidden = true; }
      function showAtBtn() {
        var rect = btn.getBoundingClientRect();
        positionAtPoint(rect.left + rect.width / 2, rect.bottom + 8);
        tooltip.hidden = false;
      }

      btn.addEventListener('mouseenter', showAt);
      btn.addEventListener('mousemove', followCursor);
      btn.addEventListener('mouseleave', function () { setTimeout(function () { if (!tooltip.matches(':hover')) hideTooltip(); }, 80); });
      btn.addEventListener('click', function (e) { e.preventDefault(); if (tooltip.hidden) showAtBtn(); else hideTooltip(); });
      btn.addEventListener('focus', showAtBtn);
      btn.addEventListener('blur', function () { setTimeout(hideTooltip, 100); });

      var closeBtn = tooltip.querySelector('.vm-score-bar__tooltip-close');
      if (closeBtn) closeBtn.addEventListener('click', hideTooltip);
      document.addEventListener('click', function (e) {
        if (!tooltip.hidden && !btn.contains(e.target) && !tooltip.contains(e.target)) hideTooltip();
      });
    });
  }

  function initGalleryZoom() {
    document.querySelectorAll('.vm-hero__gallery-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-zoom-src');
        if (!src) return;
        var modal = document.createElement('div');
        modal.className = 'vm-modal';
        modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
        modal.innerHTML = '<button class="vm-modal__close" aria-label="Schließen" type="button">&times;</button><img src="' + src + '" alt="">';
        modal.addEventListener('click', function (e) {
          if (e.target === modal || e.target.classList.contains('vm-modal__close')) modal.remove();
        });
        document.addEventListener('keydown', function onKey(e) {
          if (e.key === 'Escape') { modal.remove(); document.removeEventListener('keydown', onKey); }
        });
        document.body.appendChild(modal);
      });
    });
  }

  function initFadeIn() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.vm-fade-in').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); observer.unobserve(e.target); } });
    }, { threshold: 0.08 });
    document.querySelectorAll('.vm-fade-in').forEach(function (el) { observer.observe(el); });
  }

  function init() {
    setHeaderHeight(); setTabNavHeight();
    initTabs(); initCheckliste(); initDonuts(); initScoreBars();
    initScoreTooltips(); initGalleryZoom(); initFadeIn(); initMap();
    window.addEventListener('resize', function () { setHeaderHeight(); setTabNavHeight(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', function () { setHeaderHeight(); setTabNavHeight(); });
})();
